import React, { useContext } from 'react'
import {
  COLORS,
  BUTTON_SIZE,
  STUDENT_PROGRESS_STATUS,
  PANELS,
  TEXT_SIZES,
} from '@helpers/constants'
import Button from '@components/Button'
import { evaluateSectionProgress } from '@helpers/exams'
import { AppContext } from '@state/context'
import {
  setSelectedBookForProgressInspection,
  setSelectedInspectionStatus,
  setSelectedSchoolResourceForProgressInspection,
  setSelectedSchoolResourceTypeForProgressInspection,
  setSelectedSectionForProgressInspection,
} from '@state/actions/appActions'
import { openPanel } from '@state/actions/panelsActions'
import Icon from '@components/Icon'
import Text from '@components/Text'

const SectionProgressButtons = (props) => {
  const { section, resource, resourceType } = props

  const [state, dispatch] = useContext(AppContext)

  const hasExams = section.exams && section.exams.length > 0
  if (!hasExams) return null

  // if (!section) return null

  const sectionProgress = evaluateSectionProgress(section, resource?.students)

  const openProgressInspectionPanel = (status) => {
    dispatch(setSelectedInspectionStatus(status))
    dispatch(setSelectedSchoolResourceForProgressInspection(resource))
    dispatch(setSelectedSchoolResourceTypeForProgressInspection(resourceType))

    dispatch(setSelectedBookForProgressInspection(null))
    dispatch(setSelectedSectionForProgressInspection(section))

    dispatch(openPanel(PANELS.INSPECT_PROGRESS))
  }

  return (
    <div className='flex items-center justify-between gap-4 bg-black px-3 py-0.5 rounded-full'>
      <ProgressButton
        icon='SectionTagHasExamsNoAttempts'
        count={sectionProgress?.notStartedCount}
        status={STUDENT_PROGRESS_STATUS.NOT_STARTED}
        handleClick={() => {
          openProgressInspectionPanel(STUDENT_PROGRESS_STATUS.NOT_STARTED)
        }}
      />
      <ProgressButton
        icon='SectionTagHasExamsHasAttempts'
        count={sectionProgress?.inProgressCount}
        status={STUDENT_PROGRESS_STATUS.IN_PROGRESS}
        handleClick={() => {
          openProgressInspectionPanel(STUDENT_PROGRESS_STATUS.IN_PROGRESS)
        }}
      />
      <ProgressButton
        icon='SectionTagFailedCross'
        count={sectionProgress?.anyFailedCount}
        status={STUDENT_PROGRESS_STATUS.FAILED}
        handleClick={() => {
          openProgressInspectionPanel(STUDENT_PROGRESS_STATUS.FAILED)
        }}
      />
      <ProgressButton
        icon='SectionTagPassedCheckmark'
        count={sectionProgress?.allPassedCount}
        status={STUDENT_PROGRESS_STATUS.PASSED}
        handleClick={() => {
          openProgressInspectionPanel(STUDENT_PROGRESS_STATUS.PASSED)
        }}
      />
    </div>
  )
}

const ProgressButton = ({ icon, count, handleClick }) => (
  <Button size={BUTTON_SIZE.NO_PADDING} handleClick={handleClick}>
    <div className='flex items-center gap-1'>
      <Icon
        icon={icon}
        iconClasses='w-[14px] h-[17px]'
        color={COLORS.WHITE.TEXT}
      />
      <Text color={COLORS.WHITE.TEXT} size={TEXT_SIZES.XXXSMALL}>
        {count !== undefined ? count.toString() : '-'}
      </Text>
    </div>
  </Button>
)

export default SectionProgressButtons
